module.exports = __webpack_public_path__ + "static/img/platphom11.d9f34d74.png";